export const pickRandom = array => array[Math.floor(Math.random() * array.length)];

export const shuffleArray = array => {
    const copy = [...array];
    for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
};

export const makeOptions = (correctAnswer, allAnswers, distractorCount = 3) => {
    const distractors = shuffleArray(allAnswers.filter(answer => answer !== correctAnswer)).slice(0, distractorCount);
    return shuffleArray([correctAnswer, ...distractors]);
};
